export default __webpack_public_path__ + "static/3)NiceNegative-c54b436ff5438428ac9b231eb27ab41c.mp3";